import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import { _ } from "../utils/i18n";

import SectionHead from "../components/section-head";
import FilterButtonGroup from "../components/filter-button-group";
import FilterButton from "../components/filter-button";
import ImageLibpixel from "./image-libpixel.js";

const Hero = styled.div`
  display: flex;
  flex-direction: row;
  margin: 40px 0 80px 0;
  @media (max-width: 810px) {
    flex-direction: column;
    padding: 0 20px;
    margin-bottom: 40px;
  }
`;
const Img = styled(ImageLibpixel)`
  width: 60%;
  object-fit: cover;
  max-height: 500px;
  @media (max-width: 810px) {
    width: 100%;
  }
`;
const TextBox = styled.div`
  width: 40%;
  padding-left: 20px;
  @media (max-width: 810px) {
    width: 100%;
    padding-left: 0px;
    padding-top: 20px;
  }
`;
const Headline = styled.h4`
  margin: 0;
  letter-spacing: 0.5px;
`;
const InfoBox = styled.div`
  background-color: #f8d486;
  max-width: 300px;
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;
const CareerHeader = ({ post, subtitle, dateFrom, dateTo }) => {
  return (
    <div>
      <SectionHead
        title={post.title.replace("&#038;", "&").replace("&amp;", "&")}
      />
      <Hero>
        <Img
          src={post.featuredImage?.node?.sourceUrl}
          alt={post.featuredImage?.node?.altText}
        />
        <TextBox>
          <Headline>{_("Type")}:</Headline>
          <p>{subtitle}</p>
          <Headline>{_("Periode")}:</Headline>
          <p>{dateFrom}</p>
          <Headline>{_("Dine kvalifikatjoner")}</Headline>
          <FilterButtonGroup innerStyle={{ padding: 0 }}>
            {post &&
              post.categories &&
              post.categories.nodes?.map((c, i) => (
                <Link
                  key={i}
                  to={c.uri.replace("/category", "")}
                  className="no-underline"
                >
                  <FilterButton
                    label={c.name.replace("&#038;", "&").replace("&amp;", "&")}
                    variant="outlined"
                    size="small"
                  />
                </Link>
              ))}
          </FilterButtonGroup>
          <InfoBox>
            <h5 className="no-bottom-margin">{_("Søknadsfrist")}: </h5>
            <p className="no-bottom-margin">{dateTo}</p>
          </InfoBox>
        </TextBox>
      </Hero>
    </div>
  );
};

CareerHeader.propTypes = {
  dateTo: PropTypes.string,
  dateFrom: PropTypes.string,
  subtitle: PropTypes.string,
  post: PropTypes.object,
};

CareerHeader.defaultProps = {
  dateTo: undefined,
  dateFrom: undefined,
  subtitle: undefined,
  post: undefined,
};

export default CareerHeader;
